<template>
  <nav class="c-navs">
    <ul
      class="items"
      v-if="tempSett.site_menu && tempSett.site_menu.length > 0"
    >
      <li :class="{ select: select == 'index' }" @click="isActive('index')">
        <router-link to="/" class="child-link" :title="tempSett.site_menu[0]">{{
          tempSett.site_menu[0]
        }}</router-link>
      </li>
      <li
        :class="{ active: active == 'category', select: select == 'category' }"
        @click="isActive('category')"
      >
        <a class="child-link" :title="tempSett.site_menu[1]">{{
          tempSett.site_menu[1]
        }}</a>
        <ul class="navs-child many">
          <li v-for="o in list" :key="o.id">
            <h3 :class="{ active: activeChild == `/category/${o.name}` }">
              <router-link :to="`/category/${o.name}`">
                {{ o.displayName }}
              </router-link>
            </h3>
            <nav class="child-items">
              <router-link
                :to="`/category/${o.name}/${d.id}`"
                class="items"
                :class="{
                  active: activeChild == `/category/${o.name}/${d.id}`
                }"
                v-for="d in o.subCategory"
                :key="d.id"
              >
                {{ d.name }}
              </router-link>
            </nav>
          </li>
        </ul>
      </li>
      <li
        class="not-fold"
        :class="{ active: active == 'live', select: select == 'live' }"
        @click="isActive('live')"
      >
        <router-link
          to="/live"
          class="child-link"
          :title="tempSett.site_menu[2]"
        >
          {{ tempSett.site_menu[2] }}
        </router-link>
      </li>
      <li
        class="not-fold"
        :class="{ active: active == 'demand', select: select == 'demand' }"
        @click="isActive('demand')"
      >
        <router-link
          to="/demand"
          class="child-link"
          :title="tempSett.site_menu[3]"
        >
          {{ tempSett.site_menu[3] }}
        </router-link>
      </li>
      <li
        class="fold"
        :class="{ active: active == 'list', select: select == 'list' }"
        @click="isActive('list')"
      >
        <a class="child-link">{{ tempSett.menu_videolist_wap }}</a>
        <ul class="navs-child many">
          <li>
            <h3 :class="{ active: activeChild == '/live' }">
              <router-link to="/live">
                {{ tempSett.site_menu[2] }}
              </router-link>
            </h3>
          </li>
          <li>
            <h3 :class="{ active: activeChild == '/demand' }">
              <router-link to="/demand">
                {{ tempSett.site_menu[3] }}
              </router-link>
            </h3>
          </li>
        </ul>
      </li>
      <li
        v-if="tempSett.isLogin"
        class="fold"
        :class="{ active: active == 'user', select: select == 'user' }"
        @click="isActive('user')"
      >
        <a class="child-link">我</a>
        <ul class="navs-child many">
          <li v-if="!isLogin">
            <h3>
              <a @click="login()">{{ $t("LOG_IN") }}</a>
            </h3>
          </li>
          <li v-if="!isLogin">
            <h3>
              <a @click="reg()">{{ $t("REGISTERED") }}</a>
            </h3>
          </li>
          <li class="t-right" v-if="isLogin">
            <span>{{ $t("HELLO") }} {{ contactInfo.name }}</span>
            <a class="u-ml15 t-blue" @click="logout()">{{ $t("DROP_OUT") }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import account from "../services/account";
import { interact } from "fire-wind-water/tools/interact";
import { ck } from "fire-wind-water/cookie";
import { $subscriber } from "fire-wind-water/tools/subscriber";
import { URLS } from "fire-wind-water/url";

const tenantId = URLS.getURL("tenantId");
export default {
  name: "Navs",
  data() {
    return {
      list: [],
      active: "",
      activeChild: "",
      select: "index",
      isLogin: false,
      backUrl: "&backUrl=" + encodeURIComponent(window.location.href),
      contactInfo: {},
      tenantId: tenantId,
      tempSett: {}
    };
  },
  methods: {
    getList() {
      account.getCategory({ tenantId }).then(data => {
        if (data.result == 0) {
          this.list = data.content.category;
          this.$store.dispatch("actionsCategory", { list: this.list });
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    isActive(o) {
      this.select = o;
      if (this.active != o) {
        this.active = o;
      } else {
        this.active = null;
      }
    },
    initLogin() {
      this.isLogin = false;
      if (this.tempSett.registrationFormId) {
        const user = ck.cookie(`smarketMember_${this.tempSett.schemaId}`);
        if (user) {
          this.isLogin = true;
        }
      }
    },
    logout() {
      this.isLogin = false;
      const user = ck.cookie(`smarketMember_${this.tempSett.schemaId}`);
      if (user) {
        account.logout({
          globalUserId: ck.cookie("globalUserId"),
          schemaId: this.tempSett.schemaId,
          sess: user.session
        });
      }
      ck.removeCookie(`smarketMember_${this.tempSett.schemaId}`, {
        path: "/",
        domain: window.$sk.config.domain
      });
    },
    isSelect() {
      // console.log('this.$route', this.$route);
      let rname = this.$route.name || "index",
        rpath = this.$route.path;
      this.select = rname.toLocaleLowerCase();
      /** 防止页面加载时，直接打开菜单 */
      // this.active = rname.toLocaleLowerCase();
      this.activeChild = rpath;
      if (
        interact.isMobile == 1 &&
        (this.select == "live" || this.select == "demand")
      ) {
        this.select = "list";
      }
    },
    login() {
      if (this.tempSett.registrationFormId == 0) {
        this.$message.error("尚未配置注册表单");
      } else {
        window.location.href = `${window.$sk.$help.replaceDomain(
          this.tempSett.loginWapUrl
        )}${this.backUrl}`;
      }
    },
    reg() {
      if (this.tempSett.registrationFormId == 0) {
        this.$message.error("尚未配置注册表单");
      } else {
        window.location.href = `${window.$sk.$help.replaceDomain(
          this.tempSett.registerWapUrl
        )}${this.backUrl}`;
      }
    }
  },
  created() {
    this.tempSett = this.$store.getters.getterTempConfig;
    this.initLogin();
    this.getList();
    $subscriber.subscribe("contact-info", o => {
      this.contactInfo = o;
    });
    this.isSelect();
  },
  computed: {
    tempConfig() {
      return this.$store.getters.getterTempConfig;
    }
  },
  watch: {
    tempConfig(val) {
      this.tempSett = val;
      this.initLogin();
    },
    $route: {
      handler: function() {
        this.isSelect();
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>

<style scoped></style>
